import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import MainPage from '../components/MainPage';
import getTags from '../actions/api/tag/getTags';
import getWorkRecords from '../actions/api/record/getWorkRecords';
import getGroups from '../actions/api/group/getGroups';
import { isGuest, postCloseMessageForCansuke } from '../lib/tools';
import { SUCCESS_API_GET_USER_GROUPS } from '../actions/actionTypes';

const INTERVAL_TIMER = 5000;

const updateContainer = (apiToken, dispatch, params) => {
  const {
    innerRole,
    targetOperatorId,
    searchOptions,
    maxTagDepth,
    targetGroupId,
    provider,
  } = params;
  const { groupIds: timelineGroupIds, ...timelineSearchOptions } =
    searchOptions;
  const groupIds = (targetGroupId && [targetGroupId]) || timelineGroupIds;
  dispatch(
    getWorkRecords(
      apiToken,
      {
        ...timelineSearchOptions,
        groupIds,
        operatorId: isGuest(innerRole) ? targetOperatorId : undefined,
      },
      undefined,
      provider,
    ),
  );
  const { tags, isDeleted } = searchOptions;
  if (tags.depth < maxTagDepth) {
    dispatch(
      getTags(apiToken, {
        depth: tags.depth + 1,
        parentId: tags.tagId,
        groupId: targetGroupId,
        isDeleted,
      }),
    );
  }
};
const scrollTop = () => {
  // ページネーションなどでページ更新した時にスクロールバーをトップに戻す
  const obj = document.getElementById('canScrollTable');
  if (obj) {
    obj.scrollTop = 0;
  }
};
const getSearchBoxHeight = () => {
  const searchBox = document.getElementById('TimeLinePageSearchBox');
  const toolBar = document.getElementById('TimeLineToolBar');
  const height =
    (searchBox && searchBox.clientHeight) + (toolBar && toolBar.clientHeight);
  return height || 0;
};

class TimeLineContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchBoxHeight: 0,
    };
    const openCalendar = !!(
      props &&
      props.calendarData &&
      props.calendarData.name
    );
    const params = {
      innerRole: props && props.innerRole,
      targetOperatorId: props && props.targetOperatorId,
      canUpdate: !props.showUserPrompt || props.isLogin || !openCalendar,
      searchOptions: (props && props.searchOptions) || {},
      maxTagDepth: props && props.maxTagDepth,
      apiToken: props && props.apiToken,
      dispatch: (props && props.dispatch) || null,
      showUserPrompt: props && props.showUserPrompt,
      openCalendar,
      provider: props && props.provider,
      targetGroupId: props && props.targetGroupId,
      isCompanyAdmin: props && props.isCompanyAdmin,
    };
    const {
      innerRole,
      targetOperatorId,
      apiToken,
      dispatch,
      canUpdate,
      searchOptions,
      maxTagDepth,
      provider,
      targetGroupId,
    } = params;
    // dispatch({ type: 'SEARCHBOX_RESET_SEARCH_OPTIONS', caller: 'timeline' });
    dispatch(getGroups(apiToken, {}, SUCCESS_API_GET_USER_GROUPS));
    dispatch({ type: 'CLOSE_MENU' });
    if (isGuest(innerRole)) {
      dispatch({ type: 'CLOSE_FULLSCREEN' });
    } else {
      dispatch({ type: 'OPEN_TIMELINE' });
    }
    if (canUpdate) {
      updateContainer(apiToken, dispatch, {
        innerRole,
        targetOperatorId,
        searchOptions,
        maxTagDepth,
        targetGroupId,
        provider,
      });
      this.initialTimer(params);
    }
    if (provider && provider.isCansuke) {
      // ブラウザ終了時に送信する
      window.addEventListener('beforeunload', postCloseMessageForCansuke);
    }
  }

  componentDidMount() {
    const searchBoxHeight = getSearchBoxHeight();
    this.setState({ searchBoxHeight });
  }

  shouldComponentUpdate(props, state) {
    scrollTop();
    const resizedSearchBoxHeight = getSearchBoxHeight();
    const curSearchBoxHeight = state.searchBoxHeight;
    if (resizedSearchBoxHeight !== curSearchBoxHeight) {
      this.setState({ searchBoxHeight: resizedSearchBoxHeight });
    }
    const openCalendar = !!(
      props &&
      props.calendarData &&
      props.calendarData.name
    );
    const params = {
      innerRole: props && props.innerRole,
      targetOperatorId: props && props.targetOperatorId,
      searchOptions: props && props.searchOptions,
      searchOptionsError: props && props.searchOptionsError,
      maxTagDepth: props && props.maxTagDepth,
      apiToken: props && props.apiToken,
      dispatch: (props && props.dispatch) || null,
      showUserPrompt: props && props.showUserPrompt,
      openCalendar,
      provider: props && props.provider,
      targetGroupId: props && props.targetGroupId,
    };
    const { searchOptionsError } = params;
    if (
      !searchOptionsError.recordedDateFrom &&
      !searchOptionsError.recordedDateTo
    ) {
      this.initialTimer(params);
    }
    return true;
  }

  componentWillUnmount() {
    this.closeTimer();
    const { dispatch } = this.props;
    dispatch({ type: 'SEARCHBOX_RESET_SEARCH_OPTIONS', caller: 'timeline' });
  }

  initialTimer(params) {
    const {
      innerRole,
      targetOperatorId,
      searchOptions,
      maxTagDepth,
      apiToken,
      dispatch,
      showUserPrompt,
      openCalendar,
      provider,
      targetGroupId,
    } = params;
    this.closeTimer();
    if (dispatch && apiToken && !showUserPrompt && !openCalendar) {
      const apiParams = {
        innerRole,
        targetOperatorId,
        searchOptions,
        maxTagDepth,
        targetGroupId,
        provider,
      };
      updateContainer(apiToken, dispatch, apiParams);
      this.mainTimer = setInterval(
        () => updateContainer(apiToken, dispatch, apiParams),
        INTERVAL_TIMER,
      );
    }
  }

  closeTimer() {
    if (this.mainTimer !== undefined) {
      clearInterval(this.mainTimer);
      delete this.mainTimer;
    }
  }

  render() {
    const { isLogin } = this.props;
    const { searchBoxHeight } = this.state;
    return (
      (!isLogin && <Redirect to="/login" />) || (
        <MainPage searchBoxHeight={searchBoxHeight} />
      )
    );
  }
}

TimeLineContainer.propTypes = {
  innerRole: PropTypes.number.isRequired,
  targetOperatorId: PropTypes.number.isRequired,
  isLogin: PropTypes.bool.isRequired,
  apiToken: PropTypes.string.isRequired,
  searchOptions: PropTypes.object.isRequired,
  searchOptionsError: PropTypes.object.isRequired,
  maxTagDepth: PropTypes.number.isRequired,
  showUserPrompt: PropTypes.bool.isRequired,
  calendarData: PropTypes.object.isRequired,
  provider: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  targetGroupId: PropTypes.string.isRequired,
  isCompanyAdmin: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  innerRole: state.main.innerRole,
  targetOperatorId: state.main.userInfo.operatorId,
  isLogin: state.main.isLogin,
  compatibleInfo: state.main.compatibleInfo,
  apiToken: state.main.apiToken,
  searchOptions: state.timeline.searchOptions,
  searchOptionsError: state.timeline.searchOptionsError,
  maxTagDepth: state.timeline.selectOptions.maxDepth,
  showUserPrompt: state.userPrompt.showUserPrompt,
  calendarData: state.main.calendarData,
  provider: state.main.provider,
  targetGroupId: state.main.targetGroupId,
  isCompanyAdmin: state.main.isCompanyAdmin,
});

export default connect(mapStateToProps)(TimeLineContainer);
